<template>
	<div>
		<list-equipments-component :equipment-type="equipmentType" :btn-add-label="FormMSG(364, 'Add trailer')" />
	</div>
</template>

<script>
import languageMessages from '@/mixins/languageMessages';
import globalMixin from '@/mixins/global.mixin';
import { SPE_GENERATOR_TYPE, SPE_TRAILER_TYPE } from '../../../../shared/constants';
import ListEquipmentsComponent from './ListEquipmentsComponent.vue';

export default {
	name: 'ListProductionTrailers',
	components: { ListEquipmentsComponent },

	mixins: [languageMessages, globalMixin],

	data() {
		return {
			equipmentType: SPE_TRAILER_TYPE
		};
	}
};
</script>
